import { Pressable, Text, View } from 'react-native';

import type { WorkspaceRootKind } from '@/lib/blocks/workspace-empty';

type WorkspaceRootEmptyStateProps = {
  kind: WorkspaceRootKind;
  onCreatePage?: () => void;
};

const COPY: Record<
  WorkspaceRootKind,
  { title: string; body: string; action: string }
> = {
  family: {
    title: 'Nothing here yet',
    body: 'Create pages to collect notes, plans, and shared family knowledge.',
    action: 'New family page',
  },
  personal: {
    title: 'Nothing here yet',
    body: 'Create pages for your private notes and drafts.',
    action: 'New personal page',
  },
};

export function WorkspaceRootEmptyState({ kind, onCreatePage }: WorkspaceRootEmptyStateProps) {
  const copy = COPY[kind];

  return (
    <View className="mx-auto mb-8 mt-2 w-full max-w-content px-page">
      <View className="max-w-lg rounded-xl border border-dashed border-border bg-surface-raised/60 px-6 py-8">
      <Text className="text-lg font-semibold text-fg">{copy.title}</Text>
      <Text className="mt-2 text-sm leading-5 text-muted">{copy.body}</Text>
      {onCreatePage ? (
        <Pressable
          className="mt-5 self-start rounded-lg bg-accent px-4 py-2"
          onPress={onCreatePage}
        >
          <Text className="text-sm font-medium text-fg-inverse">{copy.action}</Text>
        </Pressable>
      ) : null}
      </View>
    </View>
  );
}
